module.exports = __webpack_public_path__ + "img/bookmark-check.c53568e0.svg";